import { createTokenStorage } from '@bos/openid-connect';

export const tokenStorage = createTokenStorage('valhalla');
